import React from 'react'
import PropTypes from 'prop-types'
import PDFContainer from 'shared/Components/ItemContent/ItemContent/types/PDFContainer'
import Image from './Image'

const FILE_RENDERERS = {
  pdf: PDFContainer,
  jpg: Image,
  jpeg: Image,
  png: Image,
  svg: Image,
  gif: Image,
  bmp: Image
}

function NativeViewerContainer({ item, previewMetadata }) {
  const SpecificRenderer = FILE_RENDERERS[item.item_type]
  return SpecificRenderer ? <SpecificRenderer url={previewMetadata.url} /> : null
}

NativeViewerContainer.propTypes = {
  item: PropTypes.object.isRequired,
  previewMetadata: PropTypes.object.isRequired
}

export default NativeViewerContainer
